module.exports = __webpack_public_path__ + "7b678d4397d97d42500af4c563885dfb.pdf";